import { addDays } from 'date-fns';
import React from 'react';
import CalendarDayScroll from '../../components/CalendarDayScroll';
import styled from 'styled-components/native';

const StyledContainer = styled.View`
  flex: 1;
  background-color: white;
  align-items: center;
  justify-content: center;
`;

const CalendarDayScrollExampleScreen: React.FC = () => {
  return (
    <StyledContainer>
      <CalendarDayScroll
        startDate={addDays(new Date(), -5)}
        length={28}
        events={[
          { date: addDays(new Date(), -4), completed: true },
          { date: addDays(new Date(), -2) },
          { date: addDays(new Date(), 0), completed: true },
          { date: addDays(new Date(), 2) },
          { date: addDays(new Date(), 4) }
        ]}
        onSelect={() => {
          return;
        }}
      />
    </StyledContainer>
  );
};

export default CalendarDayScrollExampleScreen;
